import { Factory } from 'rosie';

Factory.define('KbAdmin').attr('name', 'KB_ADMIN');

Factory.define('KbAdminWithDefaults').extend('KbAdmin');



// WEBPACK FOOTER //
// ./factories/location/kb_admin.js